// Constantes du geste « changer de semaine » au défilement/glissé horizontal
// de la grille Agenda (Prompt 16). Couleurs + durées centralisées ici (source
// unique). Aucun noir ni rouge vif : palette verte tendre cohérente avec le
// reste de l'agenda.
export const SWIPE_COLORS = {
  hintBg: "#2f5d4a",          // fond de la bulle d'indication
  hintSub: "#d6ecc9",         // petit libellé de la bulle
  glowSoft: "rgba(214,236,201,.55)", // dégradé de bord (intérieur)
  glowEdge: "rgba(95,143,115,.30)",  // dégradé de bord (extrémité)
  rangeFlashBg: "#d6ecc9",    // surbrillance des dates de navigation
  rangeFlashInk: "#1f3d31",
  loaderTrack: "#d6ecc9",     // anneau de chargement (piste)
  loaderActive: "#2f5d4a",    // anneau de chargement (partie active) + texte
  loaderBorder: "#d6ecc9",    // bord de la pastille
};

// Durées (ms) et mesures (px) du geste. À ne pas modifier sans mettre à jour
// la checklist de conformité du prompt.
export const SWIPE = {
  THRESHOLD: 120,   // cumul px avant changement de semaine
  FOLLOW: 0.12,     // la grille suit légèrement le geste
  EXIT_PX: 56,      // glissement de sortie
  ENTER_PX: 56,     // point de départ de l'entrée (côté opposé)
  EXIT_MS: 160,     // durée de sortie
  ENTER_MS: 240,    // durée d'entrée
  LOADER_DELAY: 300, // délai avant d'afficher la pastille de chargement
  FLASH_MS: 900,    // durée de la surbrillance des dates
  RELEASE_MS: 160,  // inactivité qui déclenche le retour doux
  HINT_HIDE_AFTER_ENTER: 200, // disparition bulle/dégradé après l'entrée
};

const MONTHS_ABBR = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];
const sow = (d) => { const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day); x.setHours(0, 0, 0, 0); return x; };

// Libellé de la semaine visée par le geste : « 12 – 18 oct. » (même mois) ou
// « 28 sept. – 4 oct. » (à cheval sur deux mois). dir = +1 futur / -1 passé.
export function weekRangeLabel(anchor, dir) {
  const base = new Date(anchor);
  base.setDate(base.getDate() + dir * 7);
  const s = sow(base);
  const e = new Date(s); e.setDate(e.getDate() + 6);
  if (s.getMonth() === e.getMonth()) return `${s.getDate()} – ${e.getDate()} ${MONTHS_ABBR[e.getMonth()]}`;
  return `${s.getDate()} ${MONTHS_ABBR[s.getMonth()]} – ${e.getDate()} ${MONTHS_ABBR[e.getMonth()]}`;
}
